import { createFileRoute, redirect } from '@tanstack/react-router'
import z from 'zod'
import { USERS_SCREEN_PERMISSIONS } from '~/components/routes/users/screens'
import { withRoutePermissions } from '~/utils/rbac'

/**
 * Ancienne fiche « Modifier un utilisateur » (MUI) : remplacée par la fiche client
 * `/users/$userId` (kanban #870, lot 3). La route reste pour les liens existants et redirige.
 */
export const Route = createFileRoute('/_authenticated/users/edit/$userId')({
  staticData: {
    permission: USERS_SCREEN_PERMISSIONS.app,
  },
  params: {
    parse: z.object({ userId: z.coerce.number().int().positive() }).parse,
  },
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/users/$userId', params: { userId: params.userId }, replace: true })
  },
})
withRoutePermissions(Route)
